<template>
  <section class="app-container ai-page">
    <header class="page-heading"><div><p class="eyebrow">AI 客服 · 当前站点</p><h2>{{ configuration ? 'AI 配置' : 'AI 流程' }}</h2></div><span v-if="site" class="site-badge">{{ site.siteName }} · {{ site.siteCode }}</span></header>
    <p v-if="!allowed" role="status">当前账号没有此功能权限。</p>
    <p v-else-if="!site" role="status">请先在右上角选择当前站点。</p>
    <template v-else>
      <AiSiteConfigPanel ref="workspace" v-if="configuration" :key="`config-${site.id}`" :site="site" :admin="admin" />
      <AiWorkflowStudio ref="workspace" v-else :key="`workflow-${site.id}`" :site="site" :can-edit-flow="admin" :can-edit-reply="editReply" :can-edit-directory="editDirectory" />
    </template>
  </section>
</template>
<script setup>
/* global defineProps */
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { registerSiteChangeGuard } from '@/utils/site-change-guard'
import { useStore } from '@/store'
import AiSiteConfigPanel from '../site/AiSiteConfigPanel.vue'
import AiWorkflowStudio from '../site/AiWorkflowStudio.vue'
const props = defineProps({ configuration: Boolean })
const store = useStore()
const workspace = ref(null)
let unregister = () => {}
onMounted(() => { unregister = registerSiteChangeGuard(() => workspace.value?.canLeave ? workspace.value.canLeave() : true) })
onUnmounted(() => unregister())
const admin = computed(() => store.state.user.userType === 'ADMIN')
const permissions = computed(() => store.state.user.permissions || [])
const editReply = computed(() => admin.value || permissions.value.includes('ai:reply:edit'))
const editDirectory = computed(() => admin.value || permissions.value.includes('ai:catalog:edit'))
const allowed = computed(() => props.configuration ? admin.value || permissions.value.includes('ai:config:toggle') : editDirectory.value || editReply.value || permissions.value.includes('ai:workflow:view'))
const site = computed(() => {
  const current = (store.state.user.sites || []).find(s => String(s.id) === String(store.state.user.siteId))
  return current ? { id: current.id, siteName: current.name, siteCode: current.code } : null
})
</script>
<style scoped>
.ai-page { min-width:0; padding:24px; background:#f5f7fb; min-height:calc(100vh - 100px); }
.page-heading { display:flex; justify-content:space-between; align-items:center; gap:16px; margin-bottom:24px; }
h2 { margin:6px 0 0; font-size:24px; color:#23334d; }.eyebrow { margin:0; font-size:12px; color:#718096; }.site-badge { padding:8px 14px; border:1px solid #dce5ef; border-radius:20px; background:white; color:#52637b; }
@media(max-width:700px) { .ai-page { padding:12px; }.page-heading { flex-wrap:wrap; } }
</style>
